<template>
  <div class="upload-progress">
    <div>{{ `视频上传中 (${Math.round(percent)}%)` }}</div>
    <div class="progress-persent">
      <div :style="{ width: percent + '%' }"></div>
    </div>
    <div
      class="upload-cancel-btn"
      @click="cancelHttp"
    >
      取消
    </div>
  </div>
</template>
<script>
export default {
  name: 'UplaodProgress',
  props: {
    percent: {
      type: Number,
      required: true,
      default: 0
    }
  },
  methods: {
    cancelHttp() {
      this.$emit('cancelHttp');
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-progress {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.progress-persent {
  width: 391px;
  height: 10px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 15px 0 30px;

  > div {
    width: 200px;
    height: 10px;
    background-color: #2f58fe;
    border-radius: 5px;
  }
}
.upload-cancel-btn {
  width: 100px;
  height: 40px;
  line-height: 38px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: #2f58fe;
    border-color: #2f58fe;
  }
}
</style>
